import React from "react"
import { makeStyles } from '@material-ui/core/styles';

import mixin from '../utils/mixin'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Slider from '@material-ui/core/Slider';
import IconButton from '@material-ui/core/IconButton';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';

import apiConfig from '../api-config'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mapForcast: {
    paddingBottom: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  buttonArea: {
    paddingBottom: theme.spacing(2),
  },
  player: {
    position: `relative`,
  },
  playButton: {
    position: `absolute`,
    top: `50%`,
    left: `50%`,
    WebkitTransform: `translate(-50%,-50%)`,
    transform: `translate(-50%,-50%)`,
    margin: 0,
    padding: 0,
  },
  img: {
    width: `100%`,
  },
  link: {
    fontSize: `1.2rem`
  },
}));

export const WeatherMap = ({ data, updateParams, currentParams }) => {
  const classes = useStyles();

  const [currentDate, setCurrentDate] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [image1, setImage1] = React.useState();
  const [image2, setImage2] = React.useState();
  const [image3, setImage3] = React.useState(); 

  // 1: 実況・24・48時間予想図 iframe, 2: gfs by api in data.
  const [type, setType] = React.useState(1);

  // timer
  const [current, setCurrent] = React.useState(0);
  const refTimer = React.useRef(current)

  // 実況, 24, 48画像
  const threeImageInfo = [
    {key: 'spas', value: '実況'},
    {key: 'fsas24', value: '24時間'},
    {key: 'fsas48', value: '48時間'},
  ]

  React.useEffect(() => {
    refTimer.current = current
  }, [current])

  const [timerId, setTimerId] = React.useState(0)

  const timer = () => {
    let n = refTimer.current + 1;
    if (n >= images.length) {
      n = 0;
    }
    setCurrentDate(images[n]["datetime"]);
    setCurrent(n);
  }

  const [pause, setPause] = React.useState(true)
  const handlePause = () => {
    clearInterval(timerId)
    setPause(true)
  }

  const [isPlayer, setIsPlayer] = React.useState(true)
  const handleResume = () => {
    setTimerId(setInterval(timer, 700))
    setPause(false)

    // 再生中はボタンを削除
    setTimeout(function() {
      setIsPlayer(false);
    }, 2000)
  }
  const handleImage = () => {
    setIsPlayer(!isPlayer);
  }
  // timer

  const params = [...new URLSearchParams(currentParams).entries()].reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});

  React.useEffect(() => {
    // 実況、24,48
    setImage1(`${apiConfig.url}/wxmap.php?wxpd=TC8g6Fre&mapid=${threeImageInfo[0].key}`)
    setImage2(`${apiConfig.url}/wxmap.php?wxpd=TC8g6Fre&mapid=${threeImageInfo[1].key}`)
    setImage3(`${apiConfig.url}/wxmap.php?wxpd=TC8g6Fre&mapid=${threeImageInfo[2].key}`)

    // 週間天気（content.js側で取得されてくる）
    const loc = data.loc;
    const images = data.loc[loc.mapfield].dates.map((a, i) => {

      //const filename = `${loc.dataid}_${loc.mapfield[0]}_${loc.type}_${loc.mapid}_${a}.${loc.imgtype}`;
      //const url = `https://${loc.domain}${loc.dir}/${loc.datadate}/${filename}`;
      const fore = params.int * i
      const url = `${apiConfig.url}map.php?id=${loc.id}&token=${process.env.GATSBY_WEATHER_API_TOKEN}${currentParams}&fore=${fore}&out=img`;
      const img = new Image();
      img.src = url;
      //console.log(img.src)
      //img.onload
      return {datetime: mixin.formatDate(a), url: img.src}
    });
    setImages(images);
    setCurrentDate(images[0]["datetime"]);
  }, []);

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const handleSlideChange = (event, newValue) => {
    setCurrentDate(images[newValue]["datetime"]);
    setCurrent(newValue);
  }

  const iframeUrl = "https://www.jma.go.jp/bosai/weather_map/#weather-map-table"
  return (
    <React.Fragment>
      <div id="map" className={classes.mapForcast}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={12} md={6}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">データタイプ</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                onChange={handleChange}
              >
                <MenuItem value={1}>実況・24・48時間予想図</MenuItem>
                <MenuItem value={2}>週間予想天気図</MenuItem>
              </Select>
            </FormControl>
            { type === 2 ? (
              <div id="gfs">
                { images.length > 0 &&
                  <div className={classes.player}>
                    <img
                      src={images[current]["url"]}
                      className={classes.img}
                      alt={images[current]["datetime"]}
                      onClick={handleImage}
                    />
                    { isPlayer && <div className={classes.playButton}>
                      { pause ? (
                        <IconButton size="medium" aria-label="player" onClick={handleResume}>
                          <PlayCircleOutlineIcon style={{fontSize: 64}} />
                        </IconButton>
                      ) : (
                        <IconButton size="medium" aria-label="player" onClick={handlePause}>
                          <PauseCircleOutlineIcon style={{fontSize: 64}} />
                        </IconButton>
                      )}
                    </div>
                    }
                  </div>
                }
                <Typography variant="h6" component="p">
                  {currentDate}
                </Typography>
                <Slider
                  value={current}
                  onChange={handleSlideChange}
                  aria-labelledby="range-slider"
                  min={0}
                  max={images.length-1}
                />
              </div>
            ) : (
              <div id="weather-map">
                <div>実況</div>
                <img
                  src={image1}
                  className={classes.img}
                  alt={threeImageInfo[0].value}
                />
                <div>24時間</div>
                <img
                  src={image2}
                  className={classes.img}
                  alt={threeImageInfo[1].value}
                />
                <div>48時間</div>
                <img
                  src={image3}
                  className={classes.img}
                  alt={threeImageInfo[2].value}
                />
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
};

export default WeatherMap;